import Advanced from 'app/developer-v3/pages/advanced';
import Environment from 'app/developer-v3/pages/advanced/Environment';
import Export from 'app/developer-v3/pages/advanced/Export';
import Legacy from 'app/developer-v3/pages/advanced/Legacy';
import Middleware from 'app/developer-v3/pages/advanced/Middleware';
import RequestTemplate from 'app/developer-v3/pages/advanced/RequestTemplate';
import Source from 'app/developer-v3/pages/advanced/Source';
import Settings from 'app/developer-v3/pages/advanced/Settings';

export default {
  component: Advanced,
  routes: {
    '.': {
      onEnter({ router, routeTo }) {
        routeTo(`${router.next.url}/environment`);
      },
    },
    environment: Environment,
    'request-template': RequestTemplate,
    middleware: Middleware,
    legacy: Legacy,
    export: Export,
    source: Source,
    settings: Settings,
  },
};
